const PLATFORM_SETTINGS = 'PLATFORM_SETTINGS';

const state = {
  storeSendSchedule: null,
  settings: null,
  stores: null,
  creditCards: null,
  cities: null,
  countries: null,
  currencies: null,
  projects: null,
  divisions: null,
  phoneLines: null,
  storeNotificationSettings: null,
  globalModalData: null,
  globalDrawerData: null,
  storeRelations: null,
  runners: null,
  callBackActions: null,
  activeNotifications: {},
  usersData: {},
  isUpdating: {},
  isMobile: false,
  isGlobalDrawerOpen: false,
  storeDeliverySettings: null,
  dynamicData: {},
};

import api from "@/api";

const getters = {
  settings: state => state.settings,
  // stores: state => state.stores,
  stores: (state) => {
    if (!state.isUpdating.stores && !state.stores) {
      getRecords('stores');
    }
    return state.stores;
  },
  creditCards: (state) => {
    if (!state.isUpdating.creditCards && !state.creditCards) {
      getRecords('creditCards');
    }
    return state.creditCards;
  },
  storeSendSchedule: (state) => {
    if (!state.isUpdating.storeSendSchedule && !state.storeSendSchedule) {
      getRecords('storeSendSchedule');
    }
    return state.storeSendSchedule;
  },
  isUpdating: state => state.isUpdating,
  isMobile: state => state.isMobile,
  isGlobalDrawerOpen: state => state.isGlobalDrawerOpen,
  cities: state => state.cities,
  countries: state => state.countries,
  currencies: state => state.currencies,
  projects: state => state.projects,
  divisions: state => state.divisions,
  phoneLines: state => state.phoneLines,
  storeNotificationSettings: state => state.storeNotificationSettings,
  globalModalData: state => state.globalModalData,
  globalDrawerData: state => state.globalDrawerData,
  storeRelations: state => state.storeRelations,
  runners: state => state.runners,
  callBackActions: state => state.callBackActions,
  activeNotifications: state => state.activeNotifications,
  usersData: state => state.usersData,
  dynamicData: state => state.dynamicData,
};

const getRecords = async (type) => {
  state.isUpdating[type] = true;
  const {data} = await api.index('/onDemand/platform/' + type);
  if (data.success) {
    switch (type) {
      case 'storeSendSchedule':
        state[type] = data.records.reduce((acc, s) => {
          if (!acc[s.object_id]) acc[s.object_id] = {};
          acc[s.object_id][s.option] = s.sub_value;
          return acc;
        }, {})
        if (data.extra_records) {
          state[type].extraRecords = data.extra_records;
        }
        break;
      default:
        state[type] = data.records;
        break;
    }
    state.isUpdating[type] = false;
  }
};

const actions = {
  setStoreSendSchedule({dispatch, commit}, payload) {
    commit('platform_stores_send_schedule', payload);
  },
  setStoreRelations({dispatch, commit}, payload) {
    commit('platform_stores_relations', payload);
  },
  setSettings({dispatch, commit}, payload) {
    commit(PLATFORM_SETTINGS, payload);
  },
  setStores({dispatch, commit}, payload) {
    commit('platform_stores', payload);
  },
  setProjects({dispatch, commit}, payload) {
    commit('platform_projects', payload);
  },
  setCities({dispatch, commit}, payload) {
    commit('platform_cities', payload);
  },
  setCurrencies({dispatch, commit}, payload) {
    commit('platform_currencies', payload);
  },
  setCountries({dispatch, commit}, payload) {
    commit('platform_countries', payload);
  },
  setDivisions({dispatch, commit}, payload) {
    commit('platform_divisions', payload);
  },
  setPhoneLines({dispatch, commit}, payload) {
    commit('platform_phoneLines', payload);
  },
  setStoreNotificationSettings({dispatch, commit}, payload) {
    commit('platform_store_notification_settings', payload);
  },
  setGlobalModalData({dispatch, commit}, payload) {
    commit('platform_global_modal_data', payload);
  },
  setGlobalDrawerData({dispatch, commit}, payload) {
    commit('platform_global_drawer_data', payload);
  },
  setRunners({dispatch, commit}, payload) {
    commit('platform_runners', payload);
  },
  setCallBackActions({dispatch, commit}, payload) {
    commit('callBack_action', payload);
  },
  setActiveNotifications({dispatch, commit}, payload) {
    commit('platform_active_notifications', payload);
  },
  setUsersData({dispatch, commit}, payload) {
    commit('platform_users_data', payload);
  },
  setIsMobile({dispatch, commit}, payload) {
    commit('platform_isMobile', payload);
  },
  setIsGlobalDrawerOpen({dispatch, commit}, payload) {
    commit('platform_isGlobalDrawerOpen', payload);
  },
  setDynamicData({dispatch, commit}, payload) {
    commit('platform_setDynamicData', payload);
  },
};

const mutations = {
  [PLATFORM_SETTINGS](state, payload) {
    state.settings = payload;
  },
  platform_setDynamicData(state, payload) {
    state.dynamicData = payload;
  },
  platform_stores_send_schedule(state, payload) {
    state.storeSendSchedule = payload;
  },
  platform_store_notification_settings(state, payload) {
    state.storeNotificationSettings = payload;
  },
  platform_stores(state, payload) {
    state.stores = payload;
  },
  platform_creditCards(state, payload) {
    state.creditCards = payload;
  },
  platform_projects(state, payload) {
    state.projects = payload;
  },
  platform_cities(state, payload) {
    state.cities = payload;
  },
  platform_currencies(state, payload) {
    state.currencies = payload;
  },
  platform_countries(state, payload) {
    state.countries = payload;
  },
  platform_divisions(state, payload) {
    state.divisions = payload;
  },
  platform_phoneLines(state, payload) {
    state.phoneLines = payload;
  },
  platform_global_modal_data(state, payload) {
    state.globalModalData = payload;
  },
  platform_global_drawer_data(state, payload) {
    state.globalDrawerData = payload;
  },
  platform_stores_relations(state, payload) {
    state.storeRelations = payload;
  },
  platform_runners(state, payload) {
    state.runners = payload;
  },
  callBack_action(state, payload) {
    state.callBackActions = payload;
  },
  platform_active_notifications(state, payload) {
    state.activeNotifications = payload;
  },
  platform_users_data(state, payload) {
    state.usersData = payload
  },
  platform_isMobile(state, payload) {
    state.isMobile = payload
  },
  platform_isGlobalDrawerOpen(state, payload) {
    state.isGlobalDrawerOpen = payload
  },
  platform_isUpdating(state, payload) {
    state.isUpdating = payload
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
